import React from 'react'
import { SvgProps } from 'src/shared/types/svg-props-type'

export const IconContactsAndCrm = (props?: SvgProps) => (
  <svg
    width="26"
    height="32"
    viewBox="0 0 82 88"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>{props?.title}</title>
    <path
      d="M68.8283 0.255975C76.0939 0.256119 82.0001 5.78834 82.0001 12.5695V75.4445C81.9999 82.225 76.0936 87.7558 68.8283 87.756H18.5939C10.875 87.7869 4.87514 81.5215 5.42202 74.381H2.8439C-0.453003 74.3029 -0.437303 69.7716 2.8439 69.6935H13.0001C16.2967 69.6463 16.2967 65.0531 13.0001 65.006H2.8439C-0.453003 64.9279 -0.437303 60.3966 2.8439 60.3185H5.42202V51.0372H2.8439C-0.437303 50.9747 -0.437303 46.3966 2.8439 46.3497H13.0001C16.2967 46.3026 16.2967 41.7093 13.0001 41.6622H2.8439C-0.437303 41.5997 -0.437303 37.0372 2.8439 36.9747H5.42202V27.6935H2.8439C-0.437303 27.6154 -0.437303 23.0685 2.8439 23.006H13.0001C16.2967 22.9432 16.2967 18.3812 13.0001 18.3185H2.8439C-0.437303 18.2404 -0.437303 13.6935 2.8439 13.631H5.42202C4.87517 6.4905 10.8752 0.224777 18.5939 0.255975H68.8283ZM44.2589 25.631C36.7778 25.6311 30.7133 31.6958 30.713 39.1769C30.713 44.2037 33.4516 48.5911 37.5177 50.9288C29.9989 52.7696 27.2196 57.5458 26.2208 60.3136C25.833 61.3895 26.6786 62.3798 27.8224 62.38H60.7257C61.8615 62.3798 62.6999 61.4018 62.3263 60.3292C61.3592 57.5529 58.6183 52.7354 51.0363 50.9073C55.0826 48.5645 57.8048 44.1889 57.8048 39.1769C57.8046 31.6957 51.7402 25.631 44.2589 25.631Z"
      fill="var(--default-icon-color)"
    ></path>
  </svg>
)
